export default function () {
  const widgetName = "headerTryOutButton";
  const widgetOpts = headerTryOutButtonOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      if (widgetData.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        customHeaderButton(widgetData);
      }
    },
  });

  function customHeaderButton(widgetData) {
    const { Title, URL } = widgetData[0];
    const customButton = $(`#${widgetName}`);
    // customButton.attr('href', URL);
    // URL is now managed in the Widget Manager to help with Pardot script performance
    customButton.text(Title);
  }
}
